// extracted by mini-css-extract-plugin
module.exports = {"shadow":"DatePickerStyles_shadow__1-rrM","dates-wrapper":"DatePickerStyles_dates-wrapper__1smr6"};